<script>
import { getParentNodes } from '@utils/dom'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      lang_menu: false,
    }
  },
  computed: {
    ...mapState(['common']),
  },
  beforeMount() {
    document.body.addEventListener('click', this.onBodyClick)
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.onBodyClick)
  },
  methods: {
    ...mapActions('common', ['SetLocale']),
    onBodyClick(e) {
      const parentNodes = getParentNodes(e.target)
      const chk1 = e.target !== this.$refs.type_lang
      const chk2 = !~parentNodes.indexOf(this.$refs.type_lang)
      if (chk1 && chk2) this.lang_menu = false
    },
    localeChange(locale) {
      this.$i18n.locale = locale
      this.SetLocale(locale)
    },
  },
}
</script>

<template>
  <div :class="[$style.langWrap]">
    <div ref="type_lang" class="lang two-hide" @click="lang_menu = !lang_menu">
      <span class="lang-title">{{ common.locales[common.locale] }}</span>
      <span class="terms-icon"></span>
    </div>
    <!-- 언어 선택 -->
    <ul v-if="lang_menu" class="drop-box two-hide">
      <li
        v-for="(name, locale) in common.locales"
        :key="name"
        :class="{ active: common.locale === locale }"
        @click="localeChange(locale)"
      >
        <span class="nation-tit">{{ name }}</span>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.langWrap {
  display: inline-block;
}
</style>
<style scoped>
.lang {
  position: relative;
  padding: 0 8px;
  cursor: pointer;
}

.lang:hover {
  text-decoration: underline;
}
.lang-title {
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  color: #fff;
}
.page-home .scroll .lang-title {
  color: #3d3d3d;
}

/* 언어 드롭박스 */
.drop-box {
  position: absolute;
  right: 30px;
  width: 100px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.drop-box li {
  position: relative;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 35px;
  padding: 0 10px;
  margin: 0;
  cursor: pointer;
}

.drop-box li.active {
  color: #1ab394;
  background-color: #ddebe8;
  border-radius: 3px;
}

.drop-box li.active span {
  color: #1ab394;
}

.nation-tit {
  font-size: 12px;
  line-height: 35px;
  color: #191919;
}

.nation-img {
  display: inline-block;
  width: 67px;
  height: 40px;
  background-repeat: no-repeat;
  background-position: 20px 10px;
  background-size: 28px 18px;
}
</style>
